import { event } from 'jquery';
import template from './template.tpl';
import {
    INDEX_RETURN_TYPE, isNeibu, isLogin, stringKVscene, POST, getCookie,
} from '../utils';
import UserMenu from './UserMenu/index.vue';
// import NavMenu from './NavMenu/index.vue';
import kaoyanLogin, { showInterestEvent, DIALOG_NO_MIMA_LOGIN_EVENT, DIALOG_NO_PASS_LOGIN_EVENT } from '../../login';
import Modal from './Modal/index.vue';

export default {
    template,
    components: {
        UserMenu,
        // NavMenu,
        Modal,
    },
    props: {},
    data: {
        title: '',
        type: '',
        scene: '',
        channelValue: '',
        zindex: 101,
        telephone: undefined,
        userMenuVisible: false,
        navMenuVisible: false,
        isNeibu: isNeibu(),
        avatarImg: undefined,
        username: undefined,
        visible: true,
        isMKaoyan: false,
        interestLabelModalVisible: false,
        userId: undefined,
        resolveInterestLabelFunc: null,
    },
    watch: {},
    computed: {
        logoutUrl() {
            let baseUrl = this.isNeibu ? '//login.neibu.koolearn.com' : '//login.koolearn.com';
            // window.location.href = `${baseUrl}/sso/logout.do?next_page=${window.location.href}`;
            return `${baseUrl}/sso/logout.do?next_page=${encodeURIComponent(window.location.href)}`;
        },
    },
    methods: {
        goBack() {
            if (this.type !== INDEX_RETURN_TYPE) {
                window.history.go(-1);
            } else if (document.referrer && document.referrer.indexOf(window.location.host) > -1) {
                window.location.href = '/'; // 回到首页
            } else {
                window.history.go(-1);
            }
        },
        showMenuBar() {
            this.navMenuVisible = true;
        },
        showUserBar() {
            this.userMenuVisible = true;
        },
        refreshLoginStatus() {
            const self = this;
            setTimeout(() => {
                if (isLogin()) {
                    self._getUserInfo().then(() => {
                        self.hideMenu();
                    });
                } else {
                    self.avatarImg = '';
                    self.username = '请先登录';
                    self.hideMenu();
                }
            }, 0);
            return this;
        },
        showInterestLabel(data) {
            this.interestLabelModalVisible = true;
            this.userId = data.userId;
        },
        changeInterestLabelModalVisible(_visible) {
            // 点击了兴趣标签
            this.interestLabelModalVisible = _visible;
            if (!_visible) {
                this.resolveInterestLabelFunc && this.resolveInterestLabelFunc(false);
            }
        },
        cancelLabelInterests() {
            // 点击了跳过按钮
            this.interestLabelModalVisible = false;
            this.resolveInterestLabelFunc && this.resolveInterestLabelFunc(true);
        },
        login(scene) {
            if (!scene && !this.scene) console.error('FixedTopHeader.login传入的scene值为null,且本身没有this.scene');
            // 初始化scene值
            let _scene;
            if (scene && scene.indexOf('M_') > -1) {
                _scene = scene;
                console.log(`当前scene：${_scene}`);
            } else {
                let obj = stringKVscene.find((item) => {
                    return item.keyword === scene;
                });
                if (obj) {
                    _scene = obj.scene;
                    console.log(`当前scene：${_scene}`);
                } else {
                    console.error('FixedTopHeader.login传入的scene值无法解析');
                }
            }
            // 登录逻辑
            return kaoyanLogin({
                f: _scene || '',
                channel: this.channelValue, // 这个值就是m-kaoyan
            }).then((data) => {
                // console.log(data);
                if (data && data.mobile) this.telephone = data.mobile;
                return this.refreshLoginStatus();
            });
        },
        getStringKVscene(keyword) {
            if (keyword && keyword.indexOf('M_') > -1) {
                return keyword;
            }
            let obj = stringKVscene.find((item) => {
                return item.keyword === keyword;
            });
            if (obj) {
                return obj.scene;
            }
            return console.error('FixedTopHeader.getStringKVscene传入的scene值无法解析');
        },

        logout() {
            this.hideMenu();
            window.location.href = this.logoutUrl;
        },
        _getUserInfo() {
            const _loginId = getCookie('sso.ssoId') || getCookie('sid');
            let baseUrl = this.isNeibu ? 'https://gnhd.neibu.koolearn.com' : 'https://hd.koolearn.com';

            return POST(`${baseUrl}/v1/user/koo-user-info?ssoId=${_loginId}`).then((data) => {
                this.avatarImg = data.headImg;
                this.username = data.username;
                return data;
            });
        },
        hideMenu() {
            this.userMenuVisible = false;
            this.navMenuVisible = false;
        },
    },
    mounted() {
        this.refreshLoginStatus();
        const self = this;
        $(window).on(DIALOG_NO_PASS_LOGIN_EVENT, (event, data) => {
            self.refreshLoginStatus();
        });
        $(window).on(DIALOG_NO_MIMA_LOGIN_EVENT, (event, data) => {
            self.refreshLoginStatus();
        });

        $(window).on(showInterestEvent, (event, data) => {
            self.showInterestLabel(data);
            self.resolveInterestLabelFunc = data.cb;
        });
    },
};
